import React from "react";
import "./Home.css";
import "animate.css";

const Home = () => {
  return (
    <div id="landing-2">
      <div className="container">
        <div className="row mt-2">
          <div className="banner ml-5 pl-5">
            <h5 className="animate__animated animate__lightSpeedInRight animate__delay-1s mt-6 pt-6 ml-4 pl-4">
              Close the distance{" "}
            </h5>
            <h5 className="animate__animated animate__lightSpeedInLeft animate__delay-2s ml-4 pl-4">
              with ready-made webVR meeting & social spaces
            </h5>
          </div>

          <div className="col-md-8 mt-5 pt-5"></div>
          <div className="col-md-4">
            <div className="row mt-5 pt-5">
              <a
                target="_blank"
                href="https://intense-wave-15227.herokuapp.com/scene-loft-business.html?avatar=2"
                className="btn"
              >
                BUSINESS DEMO
              </a>
            </div>

            <div className="row">
              <a
                target="_blank"
                href=" https://intense-wave-15227.herokuapp.com/atrium-tree.html?avatar=2 "
                className="btn"
              >
                SOCIAL DEMO
              </a>
            </div>

            <div className="row">
              <a
                target="_blank"
                href="https://intense-wave-15227.herokuapp.com/scene-classroom.html?avatar=2"
                className="btn"
              >
                CLASSROOM DEMO
              </a>
            </div>
          </div>
        </div>
        <a
          target="_blank"
          href="https://katabi-chatbot.herokuapp.com/"
          className="chatbotBtn text-center"
        >
          SUPPORT
        </a>
      </div>
    </div>
  );
};

export default Home;
